var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17085",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17085",
    transform: "translate(210 -8471)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15259",
    "data-name": "\\u9577\\u65B9\\u5F62 15259",
    width: 45,
    height: 45,
    transform: "translate(-210 8471)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Live",
    transform: "translate(-208.223 8473.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24860",
    "data-name": "\\u30D1\\u30B9 24860",
    d: "M19.377,24.852A6.125,6.125,0,1,1,25.5,18.727,6.125,6.125,0,0,1,19.377,24.852Zm0-9.333a3.208,3.208,0,1,0,3.208,3.208A3.208,3.208,0,0,0,19.377,15.518Zm8.75,11.737A1.458,1.458,0,0,1,27.1,24.77a8.563,8.563,0,0,0,0-12.087,1.458,1.458,0,1,1,2.065-2.053,11.468,11.468,0,0,1,0,16.193A1.435,1.435,0,0,1,28.127,27.255Zm-17.5.012a1.482,1.482,0,0,1-1.038-.432,11.48,11.48,0,0,1,0-16.205,1.46,1.46,0,1,1,2.065,2.065,8.552,8.552,0,0,0,0,12.075,1.458,1.458,0,0,1,0,2.065A1.482,1.482,0,0,1,10.627,27.267Z",
    transform: "translate(1.003 0.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24861",
    "data-name": "\\u30D1\\u30B9 24861",
    d: "M33.575,33.714a1.458,1.458,0,0,1-1.458-1.458,1.517,1.517,0,0,1,.443-1.062,16.065,16.065,0,0,0,0-23.334,1.46,1.46,0,1,1,2.03-2.1,18.97,18.97,0,0,1,0,27.487A1.423,1.423,0,0,1,33.575,33.714Zm-26.39,0A1.447,1.447,0,0,1,6.018,33.2,18.982,18.982,0,0,1,6.17,5.749a1.46,1.46,0,0,1,2.03,2.1,16.065,16.065,0,0,0,0,23.334,1.477,1.477,0,0,1-1.015,2.532Z",
    transform: "translate(0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveIcon);
export default __webpack_public_path__ + "static/media/liveIcon.90385e79387f0e45ca594b08a3ce160f.svg";
export { ForwardRef as ReactComponent };